//ANGULAR
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//SERVICES
import { AuthGuardService } from './core/services/auth-guard.service';
import { RoleGuardService as RoleGuard } from './core/services/role-guard.service';
import { IeComponent } from './shared/components/ie/ie.component';
import { PaymentComponent } from './shared/components/payment/payment.component';

const routes: Routes = [
  {
    path: 'admin',
    data: {
      admin: [true]
    },
    canActivate: [RoleGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'public',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'ie',
    component: IeComponent
  },
  {
    path: '',
    redirectTo: 'public',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutes { }
